import { useEffect, useState } from 'react';
import { Participant } from 'twilio-video';

export default function useParticipantNetworkQualityLevel(participant?: Participant | null) {
  const [networkQualityLevel, setNetworkQualityLevel] = useState<number | null>(
    participant?.networkQualityLevel ?? null
  );

  useEffect(() => {
    if (!participant) {
      setNetworkQualityLevel(null);
      return;
    }

    const handleNetworkQualityLevelChange = (newNetworkQualityLevel: number) =>
      setNetworkQualityLevel(newNetworkQualityLevel);

    setNetworkQualityLevel(participant.networkQualityLevel ?? null);
    participant.on('networkQualityLevelChanged', handleNetworkQualityLevelChange);
    return () => {
      participant.off('networkQualityLevelChanged', handleNetworkQualityLevelChange);
    };
  }, [participant]);

  return networkQualityLevel;
}
